import styled from 'styled-components';
import Radio from '~src/components/Radio';

export const StyledRadio = styled(Radio)`
  flex-shrink: 0;
`;

export const Input = styled.input<{ hasError: boolean }>`
  width: 100%;
  padding: 20px;
  height: 51px;
  border: none;
  border-radius: 5px;
  font-size: 16px;

  &::placeholder {
    color: #808080;
    font-weight: 300;
  }

  ${({ hasError }) => hasError && `border: 2px solid red;`}
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
`;

export const FormFieldWrapper = styled.div`
  &:not(:first-child) {
    margin-top: 20px;
  }
`;

export const Title = styled.div`
  font-size: 32px;
  line-height: 36px;
  font-weight: 300;
  color: white;
`;

export const Description = styled.div`
  margin-top: 15px;
  font-size: 18px;
  line-height: 22px;
  color: white;
`;

export const RadioLabelText = styled.span`
  font-size: 14px;
  line-height: 16px;
  font-weight: 300;
  opacity: 0.7;
  color: white;
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SubmitSuccessMessage = styled.div`
  color: white;
  text-align: center;
  font-size: 18px;
  line-height: 22px;
`;
